import { useState } from 'react';

export default function ReportUserAvatar({ user, className = '' }) {
  const [failed, setFailed] = useState(false);
  const name = user?.name || '';
  const initial = name ? name.charAt(0).toUpperCase() : '?';

  return (
    <div className={`user-cell-avatar ${className}`}>
      {user?.photo && !failed ? (
        <img src={user.photo} alt={name || 'User'} onError={() => setFailed(true)} />
      ) : (
        <span className="avatar-placeholder">{initial}</span>
      )}
    </div>
  );
}
